import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import AmenityInvoice from '../../../../components/Modal/PDF/Invoice/AmenityInvoice'
import InvoicePDF from '../../../../components/Modal/PDF/Invoice/InvoicePDF'
import MaintainceInvoice from '../../../../components/Modal/PDF/Invoice/MaintainceInvoice'
import RentInvoice from '../../../../components/Modal/PDF/Invoice/RentInvoice'
import VaraiInvoice from '../../../../components/Modal/PDF/Invoice/VaraiInvoice'
import { BuildingLink } from '../../../../env'

function PrintPreview() {
    const GST = useSelector((state) => state?.ModalReducer?.gstData)
    const hsn = useSelector((state) => state?.ModalReducer?.hsnData)
    const [imgUrl, setImgUrl] = useState()
    const [hsnn, setHSN] = useState([])
    const [gst, setGST] = useState([])
    const location = useLocation()
    const { pay } = location.state
    const navigate = useNavigate();

    const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }


    const getGstHsn = () => {
        GST?.map(gst => {
            if (gst.default == true) {
                setGST(gst.percentage)
            }
        })
        hsn?.map(hsn => {
            if (hsn.default == true) {
                setHSN(hsn.number)
            }
        })
    }

    useEffect(() => {
        getGstHsn()
        getBase64FromUrl(`${BuildingLink}tl.jpg`).then((data) => {
            setImgUrl(data);
        })
    }, [])

    return (
        <>
            <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                <span className='fs-3 base-font-600'>Back</span> </button>

            {
                pay.map((item, i) => {
                    return (
                        <div key={i}>
                            <RentInvoice data={item} hsn={hsnn} imgUrl={imgUrl} i={i + 1} />
                            <MaintainceInvoice data={item} hsn={hsnn} imgUrl={imgUrl} i={i + 1} />
                            <AmenityInvoice data={item} hsn={hsnn} imgUrl={imgUrl} i={i + 1} />
                            <VaraiInvoice data={item} hsn={hsnn} imgUrl={imgUrl} i={i + 1} />
                        </div>
                    )
                })
            }
        </>
    )
}

export default PrintPreview